import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert.js";
import Box from "@mui/material/Box/index.js";
import IconButton from "@mui/material/IconButton/index.js";
import PaginationItem from "@mui/material/PaginationItem/index.js";
import Paper from "@mui/material/Paper/index.js";
import Table from "@mui/material/Table/index.js";
import TableBody from "@mui/material/TableBody/index.js";
import TableContainer from "@mui/material/TableContainer/index.js";
import TableRow from "@mui/material/TableRow/index.js";
import TableSortLabel from "@mui/material/TableSortLabel/index.js";
import Typography from "@mui/material/Typography/index.js";
import StyledTooltip from "../../../../../components/styled-tooltip/styled-tooltip.js";
import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { format } from "date-fns";
import { Order, OrderOptions, useNoShowList } from "../../hooks/useNoShowList.js";
import { InvoiceStatus, AppointmentCancellationEnum } from "../../no-show-fee-list.types.js";
import { useClinic } from "../../providers/clinic-provider.js";
import { useLabels } from "../../providers/labels.provider.js";
import { useNoShowFilters } from "../../providers/no-show-filters-provider.js";
import InvoiceActionsPopover from "../InvoiceActionsPopover/InvoiceActionsPopover.js";
import NoShowFeeToolbar from "../NoShowFeeToolbar/NoShowFeeToolbar.js";
import RemovePatientDialog from "../RemovePatientDialog/RemovePatientDialog.js";
import { StyledTableBodyCell, StyledLink, CancellationReasonBadge, CancellationIcon, StatusBadge, StatusDot, PaginationWrapper, StyledPagination, StyledFirstPageIcon, StyledLastPageIcon, StyledNextPageIcon, StyledPrevPageIcon, PageItemsInfo, StyledTableHead, StyledTableHeaderCell } from "./NoShowFeeTable.styles.js";
import "@mui/material";
import "@tanstack/react-query";
import "../../providers/axios-provider.js";
import "axios";
import "@mui/material/List/index.js";
import "@mui/material/ListItemButton/index.js";
import "../InvoiceActionsPopover/InvoiceActionsPopover.styles.js";
import "@mui/material/Popover/index.js";
import "@mui/material/styles";
import "@mui/icons-material/Search.js";
import "@mui/material/InputAdornment/index.js";
import "use-debounce";
import "../NoShowFeeFilterPopover/NoShowFeeFilterPopover.js";
import "@mui/icons-material/Close.js";
import "@mui/material/Button/index.js";
import "@mui/material/Checkbox/index.js";
import "@mui/material/FormControlLabel/index.js";
import "@mui/material/Stack/index.js";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "@mui/system";
import "../../../../../components/date-pickers/date-picker/date-picker.js";
import "@mui/x-date-pickers";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "../../../../../type/Translations.js";
import "date-fns/locale";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "../../../../../components/slider/slider.styles.js";
import "../../../../../components/snackbar/snackbar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "../../../../../components/translations/utils.js";
import "react-i18next";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "../../../../../components/time-select/time-select.styles.js";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import "../NoShowFeeFilterPopover/NoShowFeeFilterPopover.styles.js";
import "../NoShowFeeToolbar/NoShowFeeToolbar.styles.js";
import "@mui/material/Toolbar/index.js";
import "@mui/icons-material/Comment.js";
import "@mui/icons-material/Person.js";
import "@mui/material/Autocomplete/index.js";
import "../../hooks/useInvoiceCancellation.js";
import "../../helpers.js";
import "../../hooks/useInvoiceCancellationOptions.js";
import "../../hooks/useMarkInvoiceAsPaid.js";
import "@mui/icons-material/Cancel.js";
import "@mui/icons-material/CheckCircle.js";
import "@mui/icons-material/EventBusy.js";
import "@mui/material/Link/index.js";
import "@mui/material/Pagination/index.js";
import "@mui/material/TableCell/index.js";
import "@mui/material/TableHead/index.js";
import "../../../../../components/icons/FirstPageIcon/FirstPageIcon.js";
import "../../../../../components/icons/LastPageIcon/LastPageIcon.js";
import "../../../../../components/icons/NextPageIcon/NextPageIcon.js";
import "../../../../../components/icons/PrevPageIcon/PrevPageIcon.js";
import "../../../../../components/icons/TrackerHoursIcon/TrackerHoursIcon.js";
const NoShowFeeTableHead = ({ onRequestSort, order, orderBy }) => {
  var _a;
  const { labels } = useLabels();
  const { appliedFilters } = useNoShowFilters();
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const showWaivedInvoices = Boolean((_a = appliedFilters.status) == null ? void 0 : _a.includes(InvoiceStatus.CANCELLED));
  const headCells = useMemo(
    () => [
      {
        id: "patientName",
        label: labels.tableHeader.patientName,
        numeric: false,
        orderOption: null
      },
      {
        id: "reason",
        label: labels.tableHeader.reason,
        numeric: false,
        orderOption: null
      },
      {
        id: "appointmentStartTime",
        label: labels.tableHeader.appointmentStartDate,
        numeric: true,
        orderOption: OrderOptions.appointmentStartTime
      },
      {
        id: "appointmentDetails",
        label: labels.tableHeader.appointmentDetails,
        numeric: false,
        orderOption: null
      },
      ...showWaivedInvoices ? [
        {
          id: "cancelledReason",
          label: labels.tableHeader.canceledReason,
          numeric: false,
          orderOption: null
        },
        {
          id: "employee",
          label: labels.tableHeader.employee,
          numeric: false,
          orderOption: null
        },
        {
          id: "cancelledAt",
          label: labels.tableHeader.deletionDate,
          numeric: true,
          orderOption: null
        }
      ] : [
        {
          id: "dueDate",
          label: labels.tableHeader.dueDate,
          numeric: true,
          orderOption: OrderOptions.dueDate
        },
        {
          id: "feeAmount",
          label: labels.tableHeader.feeAmount,
          numeric: true,
          orderOption: OrderOptions.feeAmount
        },
        {
          id: "status",
          label: labels.tableHeader.status,
          numeric: false,
          orderOption: null
        }
      ]
    ],
    [labels, showWaivedInvoices]
  );
  return /* @__PURE__ */ jsx(StyledTableHead, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
    headCells.map((headCell) => {
      const tooltipTitle = labels.tableHeader.tooltip[headCell.id];
      return /* @__PURE__ */ jsx(
        StyledTableHeaderCell,
        {
          align: headCell.numeric ? "right" : "left",
          padding: "normal",
          sortDirection: orderBy === headCell.orderOption ? order : false,
          children: /* @__PURE__ */ jsx(StyledTooltip, { title: tooltipTitle, placement: "bottom", disableHoverListener: !tooltipTitle, children: headCell.orderOption ? /* @__PURE__ */ jsx(
            TableSortLabel,
            {
              active: orderBy === headCell.orderOption,
              direction: orderBy === headCell.orderOption ? order : Order.ASC,
              onClick: createSortHandler(headCell.orderOption),
              children: headCell.label
            }
          ) : /* @__PURE__ */ jsx(Fragment, { children: headCell.label }) })
        },
        headCell.id
      );
    }),
    /* @__PURE__ */ jsx(StyledTableHeaderCell, {})
  ] }) });
};
const ROWS_PER_PAGE = 10;
const getTableRowsData = (noShowList) => {
  return noShowList.map((item) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      id: item.invoice.referenceId,
      patientReferenceId: item.patient.referenceId,
      patientExternalId: item.patient.externalId,
      patientName: `${item.patient.firstName} ${item.patient.lastName}`,
      appointmentDetails: ((_a = item.appointment) == null ? void 0 : _a.treatment) ? `${(_b = item.appointment) == null ? void 0 : _b.treatment.name} | ${item.appointment.treatment.durationInMin} min` : "",
      appointmentStartTime: ((_c = item.appointment) == null ? void 0 : _c.appointmentStart) ?? "",
      reason: ((_d = item.appointment) == null ? void 0 : _d.cancellation) ?? null,
      createdDate: item.invoice.createdDate,
      dueDate: item.invoice.dueDate,
      feeAmount: item.invoice.amountTotal,
      feeRemaining: item.invoice.amountRemaining,
      status: item.invoice.status,
      cancelledReason: ((_e = item.invoice) == null ? void 0 : _e.cancelledReason) ?? "",
      cancelledBy: (_f = item.invoice) == null ? void 0 : _f.cancelledBy,
      cancelledAt: ((_g = item.invoice) == null ? void 0 : _g.cancelledAt) ?? "",
      invoicePdfLink: (_h = item.invoice) == null ? void 0 : _h.pdfLink
    };
  });
};
const NoShowFeeTable = ({
  onPatientNameClick,
  onOpenTreatmentSheetClick,
  onUndoPatientRemoval,
  useSearchUser
}) => {
  var _a, _b, _c, _d, _e, _f;
  const { clinicReferenceId, isClaireClinic } = useClinic();
  const { labels } = useLabels();
  const [order, setOrder] = useState(Order.DESC);
  const [orderBy, setOrderBy] = useState(OrderOptions.appointmentStartTime);
  const [actionAnchorEl, setActionAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const { appliedFilters } = useNoShowFilters();
  const [showRemovePatientDialog, setShowRemovePatientDialog] = useState(false);
  const [page, setPage] = useState(1);
  const { data: patients } = useSearchUser({
    query: appliedFilters.searchTerm,
    isSelected: appliedFilters.searchTerm.length < 3
  });
  const patientReferenceIds = appliedFilters.searchTerm.length > 2 ? patients.map((patient) => patient.referenceId) : [];
  const patientReferenceIdsParam = appliedFilters.searchTerm.length < 3 ? void 0 : patientReferenceIds.length ? patientReferenceIds.join(",") : "00000000-0000-0000-0000-000000000000";
  const {
    data: noShowList,
    totalPages,
    totalElements,
    queryKey
  } = useNoShowList(clinicReferenceId, {
    size: ROWS_PER_PAGE,
    page: page - 1,
    sortDirection: order.toUpperCase(),
    sortBy: orderBy,
    status: ((_a = appliedFilters.status) == null ? void 0 : _a.length) ? appliedFilters.status.join(",") : void 0,
    patientReferenceIds: patientReferenceIdsParam,
    appointmentStartAfter: ((_b = appliedFilters.date) == null ? void 0 : _b.fromDate) ? format((_c = appliedFilters.date) == null ? void 0 : _c.fromDate, DATE_FORMATS.ISO_SHORT) : null,
    appointmentStartBefore: ((_d = appliedFilters.date) == null ? void 0 : _d.toDate) ? format((_e = appliedFilters.date) == null ? void 0 : _e.toDate, DATE_FORMATS.ISO_SHORT) : null
  });
  const rows = getTableRowsData(noShowList);
  useEffect(() => {
    setPage(1);
  }, [appliedFilters.date, appliedFilters.status, appliedFilters.reason, appliedFilters.searchTerm]);
  const handleRequestSort = (_, property) => {
    const isAsc = orderBy === property && order === Order.ASC;
    setOrder(isAsc ? Order.DESC : Order.ASC);
    setOrderBy(property);
  };
  const handleActionMenuClick = (event, row) => {
    setActionAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };
  const handleRemoveActionClick = () => {
    setShowRemovePatientDialog(true);
    setActionAnchorEl(null);
  };
  const handleActionMenuClose = () => {
    setActionAnchorEl(null);
    setSelectedRow(null);
  };
  const handleOpenTreatmentSheetActionClick = () => {
    onOpenTreatmentSheetClick((selectedRow == null ? void 0 : selectedRow.patientExternalId) ?? "");
    setActionAnchorEl(null);
  };
  const handleOpenInvoiceActionClick = () => {
    window.open((selectedRow == null ? void 0 : selectedRow.invoicePdfLink) ?? "", "_blank");
    setActionAnchorEl(null);
  };
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };
  const pageItemsInfo = `${totalElements === 0 ? 0 : (page - 1) * ROWS_PER_PAGE + 1}-${Math.min(
    page * ROWS_PER_PAGE,
    totalElements
  )} of ${totalElements}`;
  if (page > totalPages && totalPages > 0) {
    setPage(totalPages);
  }
  const emptyRows = page > 1 ? Math.max(0, page * ROWS_PER_PAGE - totalElements) : 0;
  const emptyRowHeight = emptyRows * 52;
  const showWaivedInvoices = Boolean((_f = appliedFilters.status) == null ? void 0 : _f.includes(InvoiceStatus.CANCELLED));
  const isActionMenuOpen = Boolean(actionAnchorEl);
  return /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Paper, { children: [
    /* @__PURE__ */ jsx(NoShowFeeToolbar, {}),
    /* @__PURE__ */ jsx(TableContainer, { children: /* @__PURE__ */ jsxs(Table, { sx: { minWidth: 750 }, children: [
      /* @__PURE__ */ jsx(NoShowFeeTableHead, { order, orderBy, onRequestSort: handleRequestSort }),
      /* @__PURE__ */ jsxs(TableBody, { children: [
        rows.map((row) => {
          const isOpen = row.status === InvoiceStatus.OPEN;
          return /* @__PURE__ */ jsxs(TableRow, { children: [
            /* @__PURE__ */ jsx(StyledTableBodyCell, { children: /* @__PURE__ */ jsx(StyledLink, { onClick: () => onPatientNameClick(row.patientReferenceId), children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Link 2", children: row.patientName }) }) }),
            /* @__PURE__ */ jsx(StyledTableBodyCell, { children: /* @__PURE__ */ jsxs(CancellationReasonBadge, { reason: row.reason, children: [
              /* @__PURE__ */ jsx(CancellationIcon, { reason: row.reason }),
              /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 2", children: row.reason === AppointmentCancellationEnum.CANCELED_SHORT_TERM ? labels.filter.cancellationReason.shortTerm : labels.filter.cancellationReason.noShow })
            ] }) }),
            /* @__PURE__ */ jsx(StyledTableBodyCell, { align: "right", children: row.appointmentStartTime ? format(new Date(row.appointmentStartTime), DATE_FORMATS.DAY_MONTH_YEAR) : "" }),
            /* @__PURE__ */ jsx(StyledTableBodyCell, { children: row.appointmentDetails }),
            !showWaivedInvoices ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(StyledTableBodyCell, { align: "right", children: row.dueDate ? format(new Date(row.dueDate), DATE_FORMATS.DAY_MONTH_YEAR) : "" }),
              /* @__PURE__ */ jsx(StyledTableBodyCell, { align: "right", children: new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
              }).format(row.feeAmount) }),
              /* @__PURE__ */ jsx(StyledTableBodyCell, { children: /* @__PURE__ */ jsxs(StatusBadge, { isOpen, children: [
                /* @__PURE__ */ jsx(StatusDot, { isOpen }),
                /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 2", children: isOpen ? labels.filter.paymentStatus.open : labels.filter.paymentStatus.paid })
              ] }) }),
              /* @__PURE__ */ jsx(StyledTableBodyCell, { align: "right", children: /* @__PURE__ */ jsx(IconButton, { onClick: (e) => handleActionMenuClick(e, row), children: /* @__PURE__ */ jsx(MoreVertIcon, {}) }) })
            ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(StyledTableBodyCell, { children: labels.removePatientDialog.cancellationOptions[row.cancelledReason] }),
              /* @__PURE__ */ jsx(StyledTableBodyCell, { children: row.cancelledBy }),
              /* @__PURE__ */ jsx(StyledTableBodyCell, { align: "right", children: row.cancelledAt ? format(new Date(row.cancelledAt), DATE_FORMATS.DAY_MONTH_YEAR) : "" })
            ] })
          ] }, row.id);
        }),
        emptyRows > 0 && /* @__PURE__ */ jsx(TableRow, { sx: { height: emptyRowHeight }, children: /* @__PURE__ */ jsx(StyledTableBodyCell, { colSpan: 9 }) })
      ] })
    ] }) }),
    isActionMenuOpen && (selectedRow == null ? void 0 : selectedRow.id) && /* @__PURE__ */ jsx(
      InvoiceActionsPopover,
      {
        isOpen: isActionMenuOpen,
        anchorEl: actionAnchorEl,
        onClose: handleActionMenuClose,
        onRemoveActionClick: (selectedRow == null ? void 0 : selectedRow.status) === InvoiceStatus.OPEN ? handleRemoveActionClick : void 0,
        onOpenTreatmentSheetActionClick: isClaireClinic && (selectedRow == null ? void 0 : selectedRow.patientExternalId) ? handleOpenTreatmentSheetActionClick : void 0,
        onOpenInvoiceActionClick: (selectedRow == null ? void 0 : selectedRow.invoicePdfLink) ? handleOpenInvoiceActionClick : void 0
      }
    ),
    showRemovePatientDialog && (selectedRow == null ? void 0 : selectedRow.id) && /* @__PURE__ */ jsx(
      RemovePatientDialog,
      {
        referenceId: selectedRow.id.toString(),
        patientName: selectedRow.patientName,
        onClose: () => {
          setShowRemovePatientDialog(false);
          setSelectedRow(null);
        },
        onUndo: onUndoPatientRemoval,
        noShowListQueryKey: queryKey
      }
    ),
    /* @__PURE__ */ jsxs(PaginationWrapper, { children: [
      /* @__PURE__ */ jsx(
        StyledPagination,
        {
          count: totalPages,
          page,
          onChange: handleChangePage,
          size: "small",
          siblingCount: 1,
          boundaryCount: 1,
          showFirstButton: true,
          showLastButton: true,
          disabled: totalElements <= ROWS_PER_PAGE,
          renderItem: (item) => /* @__PURE__ */ jsx(
            PaginationItem,
            {
              slots: {
                first: StyledFirstPageIcon,
                last: StyledLastPageIcon,
                next: StyledNextPageIcon,
                previous: StyledPrevPageIcon
              },
              ...item
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(PageItemsInfo, { variant: "Lato Body 2", children: pageItemsInfo })
    ] })
  ] }) });
};
export {
  NoShowFeeTable as default
};
